import { isArray } from 'lodash'
import { useState, useMemo } from 'react'
import userApi from 'src/api/userApi'
import { useGetData } from './useGetData'
import useGetWithContext from './useGetWithContext'

/**
 *
 * @param {Object} props
 * @param {Array} props.options - Mảng options gồm có label, value
 * @param {String} props.defaultValue - default value của selector
 * @param {String} props.defaultUserCacheKey - Optional
 * @returns
 */
export default function useCreateUserOptionsWithDefaultValue ({ options, defaultValue = '', defaultUserCacheKey = '' }) {
  const [isDropdownSelectOwner, setIsDropdownSelectOwner] = useState(false)

  const isDisabledGetUserDetailByDefaultValue = useMemo(() => {
    if (!defaultValue || !isArray(options)) {
      return true
    }
    const defaultOption = options.find((opt) => opt.value === defaultValue)
    return Boolean(defaultOption)
  }, [defaultValue, options])

  const getUserDetail = (...args) => {
    if (defaultUserCacheKey) {
      return useGetWithContext(defaultUserCacheKey, ...args)
    }
    return useGetData(...args)
  }

  const { data: userDetail } = getUserDetail(
    userApi.detail,
    defaultValue,
    { isDisabled: isDisabledGetUserDetailByDefaultValue },
    [defaultValue]
  )

  const defaultOption = useMemo(() => {
    if (!defaultValue || !isArray(options)) return null

    const defaultOption = options.find((opt) => opt.value === defaultValue)
    if (defaultOption) return null
    if (userDetail && userDetail.id == defaultValue) {
      return {
        value: defaultValue,
        label: userDetail.userName
      }
    }
    return {
      value: defaultValue,
      label: defaultValue
    }
  }, [userDetail, options])

  const userOptions = useMemo(() => {
    if (!isDropdownSelectOwner && defaultOption && isArray(options)) {
      return [defaultOption, ...options]
    }
    return options
  }, [defaultOption, isDropdownSelectOwner, options])

  return {
    selectorProps: {
      value: defaultValue,
      options: userOptions,
      onDropdownVisibleChange: () => setIsDropdownSelectOwner(true),
      onBlur: () => setIsDropdownSelectOwner(false)
    }
  }
}
